define((require) => {
    "use strict";

    const _                       = require("underscore");
    const GuidelineModel          = require("ui/editor/guideline/GuidelineModel");
    const HorizontalGuidelineView = require("ui/editor/guideline/HorizontalGuidelineView");
    const Marionette              = require("marionette");
    const VerticalGuidelineView   = require("ui/editor/guideline/VerticalGuidelineView");

    return Marionette.CompositeView.extend("GuidelineCompositeView", {
        className: "guidelines-view",
        _mouseDownEvent: null,

        template: _.template("<div class=\"guideline-tooltip no-scale hidden\"></div><div class=\"guidelines\"></div>"),

        itemViewContainer: ".guidelines",

        initialize: function() {
            this._viewModel = this.options.viewModel;
            this._sceneEditor = this.options.sceneEditor;
            this.listenTo(this._viewModel.get("zoomModel"), "change:scale", this.render);
        },

        getItemView: function(item) {
            switch (item.get("direction")) {
                case GuidelineModel.HORIZONTAL:
                    return HorizontalGuidelineView;

                case GuidelineModel.VERTICAL:
                    return VerticalGuidelineView;

                default:
                    throw new Error("'" + item.direction + "' is not a supported guideline direction.");
            }
        },

        appendHtml: function(collectionView, itemView, index) {
            var $elem;

            if (this.itemViewContainer) {
                $elem = collectionView.$el.find(this.itemViewContainer);
            } else {
                $elem = collectionView.$el;
            }

            if (collectionView.isBuffering) {
                collectionView.elBuffer.appendChild(itemView.el);
            } else {
                // Using all child elements instead of filtering by class name. Can't figure out why
                // it would be necessary to filter by class name, but since CollectionView's
                // appendHtml has been in production for over two years, it was chosen not to mess
                // with it.
                var children = $elem.children();
                if (index >= 0 && children.length) {
                    if (index === 0) {
                        children.eq(0).before(itemView.el);
                    } else {
                        // If the children had been filtered by class name we would get an out of
                        // bounds issue here, resulting in children.eq(index - 1) returning an empty
                        // array, and then that itemView.el wouldn't be added to the DOM.
                        children.eq(index - 1).after(itemView.el);
                    }
                } else {
                    $elem.append(itemView.el);
                }
            }
        },

        itemViewOptions: function() {
            return {
                sceneEditor: this.options.sceneEditor,
                viewModel: this.options.viewModel,
                tooltipElement: this.$el.find(".guideline-tooltip"),
                rulers: this.options.sceneEditor.sceneRulers
            };
        },

        onAfterItemAdded: function(guidelineView) {
            if (this._mouseDownEvent && !guidelineView.model.get("position")) {
                guidelineView.guidelineAdded(this._mouseDownEvent);
            }
        },

        addGuideline: function(direction, mouseDownEvent) {
            this._mouseDownEvent = mouseDownEvent;

            var newGuideline = new GuidelineModel({
                direction: direction
            });

            this._viewModel.get("activeLayerSceneModel").get("guidelines").add(newGuideline);
        },

        getViewPortOffset: function(direction) {
            var offset = {};
            var verticalOffset = 0;
            var rect = this.el.getBoundingClientRect();

            if (rect.left < 0) {
                const sceneRulers = this._sceneEditor.sceneRulers;
                verticalOffset = -rect.left + sceneRulers.verticalRuler.$el.width() * this._viewModel.get("zoomModel").get("scale");
            }

            offset[GuidelineModel.HORIZONTAL] = this._viewModel.get("contentOffsetY");
            offset[GuidelineModel.VERTICAL] = verticalOffset;

            if (direction) {
                return offset[direction];
            }

            return offset;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/guideline/GuidelineCompositeView.js